module.exports = __webpack_public_path__ + "static/media/similMaderaGris.7553e125.jpg";